import { createSlice } from "@reduxjs/toolkit";


const savedTheme = localStorage.getItem('theme') || 'light';

// App Slice
export const appSlice = createSlice({
    name: 'app',
    initialState: {
        load: false,
        // theme: 'light'
        theme: savedTheme
    },
    reducers: {
        /**
         * Set authentication details.
         * @param {AuthState} state The current state of the authentication.
         * @param {Object} action The action object.
         * @param {Object} action.payload The payload object.
         */
        showLoader: (state, action) => {
            state.load = true
        },
        setLightTheme: (state, action) => {
            state.theme = "light"
            localStorage.setItem('theme', 'light');
        },
        setDarkTheme: (state, action) => {
            state.theme = "dark"
            localStorage.setItem('theme', 'dark');
        },
        hideLoader: (state, action) => {
            state.load = false
        }
    },
});
export const { showLoader, hideLoader, setLightTheme, setDarkTheme } = appSlice.actions;

